<template>
  <div>
    <shopping
      :forceShowCarouselWeeks="showCarouselWeeks"
      :showTitle="showTitle"
      :showFamilyFareRules="showFamilyFareRules"
      :showOD="showOD"
      :showPassengers="showPassengers"
      :disableAnimations="disableAnimations"
      :dismissSummary="dismissSummary"
      :showTimeLine="showTimeLine"
      :locale="locale"
      :urls="urls"
      :showActionButton="showActionButton"
      :loadingMutationName="loadingMutationName"
      :include-searcher="includeSearcher"
      @selectFlight="selectFlight"
      @flightInfo="flightInfo = $event"
      @back="backCallback"
      @bottomMessageConfig="(v)=>bottomMessage.config=v"
      @openSearcher="() => searcherOpen = true"
      @shoppingException="() => searcherOpen = true"
      :showCalendar="showCalendar"
    />
  </div>
</template>

<script>
import shopping from 'shopping-lib/src/components/shopping/shopping.vue'
import get from 'lodash/get'

export default {
  name: 'shop',
  components: {
    shopping
  },
  inject: ['isDesktopXl'],
  watch: {
    isGoingSelected: {
      handler (newVal) {
        if (newVal && this.isDesktopXl) {
          this.$store.commit('summaryBehaviorHandler', { state: 'absolute', showSummary: true })
        }
      }
    }
  },
  data () {
    return {
      showTitle: true,
      // * Parámetro showFamilyFareRules, mientras lo habilitamos desde acá,
      // pero la idea es que venga por backend
      showFamilyFareRules: true,
      showTimeLine: true,
      showPassengers: true,
      showActionButton: true,
      showCarouselWeeks: true,
      dismissSummary: false,
      disableAnimations: false,
      showOD: true,
      selectedData: null,
      loadingMutationName: 'setLoading',
      locale: 'en',
      urls: {
        configsUrl: `${this.$store.getters.getConfigUrls ? this.$store.getters.getConfigUrls.apiUrl : 'sarasa-'}configs/`,
        carouselWeeksUrl: `${this.$store.getters.getConfigUrls ? this.$store.getters.getConfigUrls.apiUrl : 'sarasa-'}reload/`
      },
      includeSearcher: true,
      acceptTerms: false,
      flightInfo: null,
      isReturn: false,
      bottomMessage: {
        checked: false,
        config: {
          check_enabled: false,
          display: false
        }
      },
      searcherOpen: false,
      showCalendar: this.$store.getters.getGeneralSettings ? this.$store.getters.getGeneralSettings.ecommerce_setup.flight_results_with_calendar : false
    }
  },
  mounted () {
    this.$store.commit('setLoading', true)
  },
  methods: {
    selectFlight (data) {
      this.selectedData = data
      this.manageScrollByBotomMessage()
    },
    manageScrollByBotomMessage () {
      if (this.bottomMessage.config.check_enabled &&
        this.showContinueButton && !this.bottomMessageOk &&
        ((this.isRoundTrip && Boolean(this.isReturnSelected)) ||
        (!this.isRoundTrip && Boolean(this.isGoingSelected)))) {
        window.scrollTo(0, document.body.scrollHeight)
      }
    },
    continueButton () {
      this.$children[0].continueBooking()
      /* wait for animation execution */
      setTimeout(() => {
        this.isReturn = true
      }, 500)
    },
    back: function () {
      if (this.isRoundTrip && this.isReturn) {
        this.$children[0].goBack()
      } else {
        window.location.href = this.$store.getters.getGeneralSettings.ecommerce_setup.logo_redirect_url
      }
    },
    backCallback: function () {
      this.$store.commit('summaryBehaviorHandler', { state: 'absolute', showSummary: false })
      this.isReturn = false
      this.selectedData = null
      this.acceptTerms = false
    },
    goTerms: function () {
      this.$store.commit('summaryBehaviorHandler', { state: 'absolute', showSummary: false })
      this.$router.push({ name: 'terms' })
    }
  },
  computed: {
    bottomMessageOk () {
      return (this.bottomMessage.checked === this.bottomMessage.config.check_enabled || !this.bottomMessage.config.display)
    },
    continueCondition () {
      let res = false
      if (this.isRoundTrip) {
        if (this.isReturn) {
          res = Boolean(this.isReturnSelected) && this.bottomMessageOk
        } else {
          res = Boolean(this.isGoingSelected)
        }
      } else {
        // is one-way
        res = Boolean(this.selectedData) && this.bottomMessageOk
      }
      return Boolean(res && ((this.showTerms && this.acceptTerms) || !this.showTerms))
    },
    showContinueButton: function () {
      return !(!this.isDesktopXl && this.isReturn && this.showTerms && !this.acceptTerms && this.bottomMessageOk)
    },
    isGoingSelected: function () {
      return get(this.selectedData, 'going.flight')
    },
    isReturnSelected: function () {
      return get(this.selectedData, 'return.flight')
    },
    isRoundTrip: function () {
      return this.flightInfo && this.flightInfo.components.length > 1
    },
    showTerms: function () {
      let result = false
      if (get(this.flightInfo, 'configs.term_condition.term_condition')) {
        result = this.isRoundTrip ? this.isReturn : true
      }
      return result
    }
  }
}
</script>

<style lang="sass">
.flights
  width: 100%

.hide
  display: none

.noFlightsError
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  min-height: 80vh

.flightResults__shopping
  width: 100%
  padding: 0 !important

.Searcher.surface
  border-radius: 0
  border-bottom: 0
  box-shadow: none
  .datepickerInput
    &__container
      padding-top: 0
  .datepickerInput.--tag, .inputText.--tag, .inputSelect.--tag
    margin-bottom: 0.5rem
  .searchflight__formContainer
    padding-top: .5rem

.actionNav
  &-leave-to, &-enter
    transform: translateY(100%)
    opacity: 0
@media (max-width: 767px)
  .flights
    .form-group .dropdown.is-mobile-modal .dropdown-menu
      border-radius: 0
      border: 0
      padding-top: 60px
      position: fixed
      z-index: 1000
      width: 100% !important
      max-width: initial !important
      left: 0 !important
      right: initial !important
      top: -25px !important
      bottom: auto !important
      bottom: initial !important
      transform: none
      .dropdown-item
        max-width: 400px
        margin: 0 auto
  .dropdown .background
    background: rgba(10, 10, 10, 0.86)
    z-index: 1000

.searchForm__container
  box-shadow: var(--z-1)
  z-index: 1000
  position: fixed
  background-color: var(--color-surface)
  transition: width .2s ease
  padding: 0
  top: 3.5rem
  width: 100%
  left: 0
  .container
    position: relative
  .Searcher
    padding: 0
    border: 0
  .--tag
    input, select
      font-size: var(--font-size-xs) !important
  .searchForm__btnClose
    padding: 0
    width: 100%
    border: none
    background-color: var(--color-overlay-05)
    i
      opacity: .6
  .autocompleteAirport, .datepickerInput, .datepickerInput__group, .passengersComponent
    margin-bottom: 0
    input
      height: 2.5rem !important
  .datepickerInput__group, .inputText__group, .inputSelect__group
      height: 2.5rem
  .searchForm__searchBtn
    button.btn
      height: 2.5rem
  .autocompleteAirport__label
    display: none
  .searchForm__formContainer
    box-shadow: none
    padding: 1rem 0 0
  .inputRadio.--row
    .inputRadio__container
      width: auto
  .passengersSelect
    .inputSelect__input
      height: 100%
  .searchForm__datepicker
    margin-bottom: 1rem
.searcherTransition-enter-active, .searcherTransition-leave-active
  transition: all .2s ease
.searcherTransition-enter, .searcherTransition-leave-to
  opacity: 0
  transform: translateY(-1rem)
.dateNoData
  margin-top: 1.5rem
@media (min-width: 768px)
  .flights
    &.--error
      .searchForm__container
        width: 100%
        position: static
        margin: -1.5rem 0 0
        padding:  0 1rem
@media (min-width: 992px)
  .searchForm__container
    padding: 0 1rem
    .searchForm
      &__btnClose
        position: absolute
        right: 0
        top: 0.75rem
        width: auto
        padding: var(--btn-padding-y) var(--btn-padding-x)
      .flightType
        .inputRadio
          margin: .5rem 0
      .countrySettings
        align-items: center
        display: flex
      .--tag
        margin: 0.25rem 0 !important
</style>
